import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {
  Button,
  Icon,
  getTranslation,
} from '@resy/ui-kitchen';

import LocationsMenu from '../../components/LocationsMenu';
import './LocationsContainer.scss';

const LocationsContainer = (props) => {
  const {
    isMobile,
    isOpen,
    locations,
    onLocationSelect,
    onToggle,
    selectedLocation,
    hideMenu,
    hideWineLocations,
  } = props;

  if (hideMenu) return null;

  return (
    <div
      className={cx('LocationsContainer', {
        'LocationsContainer--mobile': isMobile,
        'LocationsContainer--desktop': !isMobile,
        'LocationsContainer--open': isOpen,
      })}
    >
      <div className="Selector">
        <Button
          className={cx('LocationsContainer__click-container', {
            'LocationsContainer__click-container--open': isOpen,
          })}
          onClick={onToggle}
          variant="no-style"
          aria-expanded={isOpen}
          aria-label={getTranslation({
            translationKey: 'button_location',
            translationValues: { selectedLocation },
            fallback: `Location ${selectedLocation}`,
          })}
        >
          <div>
            <div className="Selector__title">
              {selectedLocation}
            </div>
            <Icon name="caret" />
          </div>
        </Button>
        <LocationsMenu
          isOpen={isOpen}
          locations={locations}
          onLocationSelect={onLocationSelect}
          onClose={onToggle}
          selectedLocation={selectedLocation}
          hideWineLocations={hideWineLocations}
        />
      </div>
    </div>
  );
};

const locationsContainerPropTypes = {
  isMobile: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  locations: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string.isRequired,
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  onLocationSelect: PropTypes.func.isRequired,
  onToggle: PropTypes.func.isRequired,
  selectedLocation: PropTypes.string.isRequired,
  hideMenu: PropTypes.bool,
  hideWineLocations: PropTypes.bool,
};

LocationsContainer.propTypes = locationsContainerPropTypes;

LocationsContainer.defaultProps = {
  hideMenu: false,
  hideWineLocations: false,
};

LocationsContainer.displayName = 'LocationsContainer';

export { locationsContainerPropTypes };
export default LocationsContainer;
